<template>
  <div class="container">
    <table class="table table-bordered">
      <thead>
        <tr class="thead-light">
          <th>What services would you like to utilize during the Interviewing Days?</th>
          <th>Price</th>
          <th>Amount</th>
          <th>Total price</th>
        </tr>
      </thead>
      <tbody>
        <Slider option="interview"/>
        <Slider option="lunch"/>
        <Slider option="dinner-drink"/>
        <Slider option="company-case"/>
      </tbody>
    </table>
    <router-link to="/subscribe/career-expo-options" v-if="$store.getters.hasEvent('career-expo')">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/package-selection" v-else>
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/overview" v-if="valid">
      <button class="btn btn-primary">Next</button>
    </router-link>
    <button class="btn btn-primary" disabled v-else>Next</button>
  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";

export default {
  name: "interviewing-days-options",
  components: {
    Slider
  },
  computed: {
    valid() {
      const data = this.$store.state.subscriberData;
      return (
        data.Interviews > 0 ||
        data.Lunches > 0 ||
        data.Diners > 0 ||
        data.Cases > 0
      );
    }
  }
};
</script>

<style lang="scss">
td {
  min-width: 100px;
}
</style>
